import type { FC } from 'react'
import styled from '@emotion/styled'

import ButtonText from '@segment/matcha/components/ButtonText'
import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'
import Badge from '@segment/matcha/components/Badge'

import CardBase, * as CardRecipe from '@segment/matcha/recipes/Card'

import type { Recipe } from '@segment/api/types/recipe'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

export interface CardProps {
  authors?: Recipe[`authors`]
  industries?: Recipe[`industries`]
  teams?: Recipe[`teams`]
  experienceLevel?: Recipe[`experienceLevel`]
  title: Recipe[`title`]
  description: Recipe[`description`]
  slug: Recipe[`slug`]
}
const Card: FC<CardProps> = ({ authors, industries, teams, experienceLevel, title, description, slug }) => {
  const pageConfig = usePageConfig()
  return (
    <CardBase href={getAbsoluteUrl(`/recipes/${slug}`, pageConfig)}>
      <CardRecipe.Body>
        <CardRecipe.Accessories>
          <CardRecipe.AccessoriesRow>
            {industries?.map((industry, key) => (
              <Badge key={key} variant="outlined">
                {industry}
              </Badge>
            ))}
            {teams?.map((team, key) => (
              <Badge key={key} variant="outlined">
                {team}
              </Badge>
            ))}
            {experienceLevel && <Badge variant="outlined">{experienceLevel}</Badge>}
          </CardRecipe.AccessoriesRow>
        </CardRecipe.Accessories>
        <CardRecipe.Copy>
          <CardRecipe.Headline tag="h3">{title}</CardRecipe.Headline>
          <CardRecipe.Description>{description}</CardRecipe.Description>
          <CardRecipe.Accessories>
            {authors?.map(({ name, headshot }, key) => (
              <CardRecipe.AccessoriesRow key={key}>
                <StyledCardRecipeAuthor contentfulLoader={true} alt={name} size="small" src={headshot.src} key={name} />
                <CardRecipe.Label variant="textTiny">Made by {name}</CardRecipe.Label>
              </CardRecipe.AccessoriesRow>
            ))}
          </CardRecipe.Accessories>
        </CardRecipe.Copy>
        <CardRecipe.Action alignment="left">
          <ButtonText iconEnd={ChevronRightIcon}>Use this recipe</ButtonText>
        </CardRecipe.Action>
      </CardRecipe.Body>
    </CardBase>
  )
}

const StyledCardRecipeAuthor = styled(CardRecipe.Author)`
  margin: 0;
`

export default Card
